import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableCell from "@amzn/meridian/table/table-cell";
import TableRow from "@amzn/meridian/table/table-row";
import {chainWalk, formQueryParams} from "../../Utility";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import Loading from "../utils/Loading";
import ErrorPage from "../utils/ErrorPage";
import {navigationAdded} from "../../actions/OptionsActions";
import {PackageStatus} from "../../enums";
import {GROUP_BY, HYPHEN, STATION_PAIR, TOTAL} from "../../constants";

class StationPair extends Component {

    render() {

        const error = this.props.error

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const stationPairs = this.getDistinctStationPairs().sort();

        if (this.props.loading && !stationPairs.length) {
            return <Loading height={"400px"}/>;
        }

        return (
            <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                   fixHeaderRowsFullWidth={true}>
                {this.renderHeadings()}
                {this.renderSubHeadings()}
                {stationPairs.map((stationPair) => (this.renderPackageMetrics(stationPair)))}
                {stationPairs.length ? this.renderTotalPackageMetrics() : null}
            </Table>
        )
    }

    getDistinctStationPairs = () => {
        const allStationPairs = [
            ...Object.keys(this.props.inductPackageMetricsMap),
            ...Object.keys(this.props.pickPackageMetricsMap),
            ...Object.keys(this.props.stowAssociateMetricsMap),
            ...Object.keys(this.props.stowFloorMetricsGroupMap),
            ...Object.keys(this.props.stowPackageMetricsMap)
        ];
        const filteredStationPairs = allStationPairs.filter(stationPair => stationPair !== "")

        return [...new Set(filteredStationPairs)];
    }

    renderHeadings = () => {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="stationPair.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="stationPair.readiness" defaultMessage="Readiness"/>
                </TableCell>
                <TableCell>
                    <FormattedMessage id="stationPair.performance" defaultMessage="Performance"/>
                </TableCell>
                <TableCell>
                    <FormattedMessage id="stationPair.stowers" defaultMessage="Stowers"/>
                </TableCell>
                <TableCell/>
            </TableRow>
        );
    }

    renderSubHeadings = () => {
        return (
            <TableRow>
                <TableCell>
                    <FormattedMessage id="stationPair.station_pair" defaultMessage="Station"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.picked" defaultMessage="Picked"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.stow_plan" defaultMessage="Stow/Plan"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.ps" defaultMessage="PS"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.missing_carts" defaultMessage="Missing carts"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.stow_rate" defaultMessage="Stow rate"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.active" defaultMessage="Active"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="stationPair.inactive" defaultMessage="Inactive"/>
                </TableCell>
            </TableRow>
        );
    }

    renderPackageMetrics = (stationPair) => {
        const combinedMetricsMap = this.getCombinedMetricsMap(stationPair)

        return (
            <TableRow highlightOnHover={true} key={stationPair} onClick={() => this.stationPairRowClicked(stationPair, combinedMetricsMap.displayLabel)}>
                <TableCell>{combinedMetricsMap.displayLabel}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.inductedPackages, stationPair, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.pickedPackages, stationPair, PackageStatus.PICKED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, stationPair, PackageStatus.STOWED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowVsPlan}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.problemSolvePackages, stationPair, PackageStatus.PROBLEM_SOLVE)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.floorsCountMissingCart}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.inactiveStowers}</TableCell>
            </TableRow>
        );
    }

    renderTotalPackageMetrics = () => {
        const combinedTotalMetricsMap = this.getCombinedTotalMetricsMap()

        return (
            <TableRow>
                <TableCell>Total</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.inductedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.pickedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.stowedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.stowVsPlan}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.problemSolvePackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.floorsCountMissingCart}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.activeStowers}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.inactiveStowers}
                </TableCell>
            </TableRow>
        );
    }

    getCombinedMetricsMap = stationPair => {
        const {
            inductPackageMetricsMap,
            pickPackageMetricsMap,
            stowAssociateMetricsMap,
            stowFloorMetricsGroupMap,
            stowPackageMetricsMap
        } = this.props;
        const defaultMetricValue = "-"

        const displayLabel = chainWalk(() => stowFloorMetricsGroupMap[stationPair].displayLabel,
            chainWalk(() => stowPackageMetricsMap[stationPair].displayLabel, HYPHEN))

        return {
            inductedPackages: chainWalk(() => inductPackageMetricsMap[stationPair].inductedPackages, defaultMetricValue),
            pickedPackages: chainWalk(() => pickPackageMetricsMap[stationPair].pickedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[stationPair].stowedPackages, defaultMetricValue),
            stowVsPlan: this.getStowVsPlan(stowPackageMetricsMap, inductPackageMetricsMap, stationPair),
            problemSolvePackages: chainWalk(() => stowPackageMetricsMap[stationPair].problemSolvePackages, defaultMetricValue),
            displayLabel: displayLabel,
            floorsCountMissingCart: chainWalk(() => stowFloorMetricsGroupMap[stationPair].floorMetrics.floorsCountMissingCart, defaultMetricValue),
            stowRate: chainWalk(() => stowPackageMetricsMap[stationPair].stowRate, defaultMetricValue),
            activeStowers: chainWalk(() => stowAssociateMetricsMap[stationPair].activeStowers, defaultMetricValue),
            inactiveStowers: chainWalk(() => stowAssociateMetricsMap[stationPair].inactiveStowers, defaultMetricValue),
        }
    }

    getCombinedTotalMetricsMap = () => {
        const {
            totalInductPackageMetrics,
            totalPickPackageMetricsMap,
            totalStowAssociateMetrics,
            totalStowFloorMetricsMap,
            totalStowPackageMetrics
        } = this.props;
        const defaultMetricValue = "-"
        const total = "Total"

        return {
            inductedPackages: chainWalk(() => totalInductPackageMetrics[total].inductedPackages, defaultMetricValue),
            pickedPackages: chainWalk(() => totalPickPackageMetricsMap[total].pickedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => totalStowPackageMetrics[total].stowedPackages, defaultMetricValue),
            stowVsPlan: this.getStowVsPlan(totalStowPackageMetrics, totalInductPackageMetrics, TOTAL),
            problemSolvePackages: chainWalk(() => totalStowPackageMetrics[total].problemSolvePackages, defaultMetricValue),
            floorsCountMissingCart: chainWalk(() => totalStowFloorMetricsMap[total].floorsCountMissingCart, defaultMetricValue),
            stowRate: chainWalk(() => totalStowPackageMetrics[total].stowRate, defaultMetricValue),
            activeStowers: chainWalk(() => totalStowAssociateMetrics[total].activeStowers, defaultMetricValue),
            inactiveStowers: chainWalk(() => totalStowAssociateMetrics[total].inactiveStowers, defaultMetricValue),
        }
    }

    getStowVsPlan = (stowPackageMetricsMap, inductPackageMetricsMap, stationPair) => {
        const stowedPackages = chainWalk(() => stowPackageMetricsMap[stationPair].stowedPackages, 0)
        const inductedPackages = chainWalk(() => inductPackageMetricsMap[stationPair].cumulativeInducted, 0)
        const stowVsPlan = inductedPackages === 0 ? 0 : stowedPackages/inductedPackages
        return (stowVsPlan * 100).toFixed(2)
    }

    stationPairRowClicked = (stationPair, displayLabel) => {
        this.props.dispatch(navigationAdded({
            key: 'Station',
            value: stationPair,
            displayValue: displayLabel
        }))
    }

    renderPackageCount = (value, stationPair, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, stationPair)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, stationPair) => {
        const params = {
            PACKAGE_STATUS: state,
            STATION_PAIR: stationPair
        }
        if (PackageStatus.PICKED === state) {
            params[GROUP_BY] =  STATION_PAIR;
        }
        return "#packageList/?" + formQueryParams(params);
    }
}

const mapStateToProps = state => ({
    loading: state.stationPairReducer.loading,
    error: state.stationPairReducer.error,
    inductPackageMetricsMap: state.stationPairReducer.inductPackageMetricsMap,
    pickPackageMetricsMap: state.stationPairReducer.pickPackageMetricsMap,
    stowAssociateMetricsMap: state.stationPairReducer.stowAssociateMetricsMap,
    stowFloorMetricsGroupMap: state.stationPairReducer.stowFloorMetricsGroupMap,
    stowPackageMetricsMap: state.stationPairReducer.stowPackageMetricsMap,
    totalInductPackageMetrics: state.stationPairReducer.totalInductPackageMetrics,
    totalPickPackageMetricsMap: state.stationPairReducer.totalPickPackageMetricsMap,
    totalStowAssociateMetrics: state.stationPairReducer.totalStowAssociateMetrics,
    totalStowFloorMetricsMap: state.stationPairReducer.totalStowFloorMetricsMap,
    totalStowPackageMetrics: state.stationPairReducer.totalStowPackageMetrics,
});

export default withRouter(connect(mapStateToProps)(StationPair));



// WEBPACK FOOTER //
// ./src/components/station-pair/StationPair.js